import React from 'react';

import { useAccount as useAccountQuery } from 'catering/hooks/query';
import PageLoadSpinner from 'components/PageLoadSpinner';
import { logError } from 'logging';

const AccountContext = React.createContext(null);
AccountContext.displayName = 'AccountContext';

function AccountProvider(props) {
  const { data: account = {}, isLoading, isError } = useAccountQuery();

  if (isLoading) {
    return <PageLoadSpinner />;
  }

  // This technically should never happen in prod since account data
  // is injected in the window object when bentobox serves the webpack app.
  if (isError) {
    logError('Failed to load account information');
  }

  return <AccountContext.Provider value={account} {...props} />;
}

function useAccount() {
  const context = React.useContext(AccountContext);
  if (context === undefined) {
    throw new Error('useAccount must be used within a AccountProvider');
  }
  return context;
}

export { AccountProvider, useAccount };
